import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import LogInModal from 'flarum/forum/components/LogInModal';
import Stream from 'flarum/common/utils/Stream';

export default function extendLogInModal() {
  let this_captcha = Stream('');
  let need_captcha = false;
  let current_identification = '';

  extend(LogInModal.prototype, 'fields', function (items) {
    // items.remove('identification');
    // items.remove('password');
    // items.remove('remember');
    // items.remove('submit');
    // items.get('identification').props.placeholder = '学工号/账号';
    items.add(
      'captcha-image',
      <div className="Form-group">
        <img
          className="Form-control--captcha"
          onclick={() => {
            this.$('.Form-control--captcha').attr('src', app.forum.attribute('apiUrl') + '/cjlu/auth/captcha?refresh=' + Date.now());
          }}
        />
      </div>,
      20
    );

    items.add(
      'captcha',
      <div className="Form-group">
        <input
          className="FormControl Form-control--captcha--input"
          name="captcha"
          type="text"
          placeholder="验证码"
          aria-label="验证码"
          bidi={this_captcha}
        />
      </div>,
      20
    );
  });

  function checkUser(value, callback = null) {
    if (!value) {
      return;
    }
    if (value === current_identification) {
      if (callback) {
        callback();
      }
      return;
    }
    current_identification = value;
    app
      .request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/cjlu/auth/check_user',
        body: {
          identification: value,
        },
      })
      .then((res) => {
        need_captcha = res.need_captcha;
        if (need_captcha) {
          $('.Form-control--captcha').css('display', 'block');
          $('.Form-control--captcha--input').css('display', 'block');
          $('.Form-control--captcha').attr('src', app.forum.attribute('apiUrl') + '/cjlu/auth/captcha?refresh=' + Date.now());
        } else {
          $('.Form-control--captcha').css('display', 'none');
          $('.Form-control--captcha--input').css('display', 'none');
        }
        if (callback) {
          callback();
        }
      });

  }

  extend(LogInModal.prototype, 'oncreate', function (original) {
    this.$('[name=identification]').attr('placeholder', '学工号/账号');
    // this.$('[name="identification"]').on('focusout', function (e) {
    //   checkUser(e.target.value);
    // });
  });

  extend(LogInModal.prototype, 'onerror', function (original) {
    // checkUser(this.identification());
  });

  override(LogInModal.prototype, 'footer', function (items) {
    let forgotPasswordUrl = 'https://authserver.cjlu.edu.cn/retrieve-password/retrievePassword/index.html#/';
    let activationUrl = 'https://authserver.cjlu.edu.cn/retrieve-password/accountActivation/index.html#/';

    return (
      <div>
        <p className="LogInModal-forgotPassword">
          <span>有统一认证账号的用户请使用其密码登录。</span>
          <a href={forgotPasswordUrl} target="_blank" rel="noreferrer">
            忘记密码？
          </a>
        </p>
        <p className="LogInModal-activate">
          <span>没有激活账号？</span>
          <a href={activationUrl} target="_blank" rel="noreferrer">
            立即激活
          </a>
        </p>
      </div>
    );
  });

  LogInModal.prototype.loginParams = function () {
    const data = {
      identification: this.identification(),
      password: this.password(),
      remember: this.remember(),
      captcha: this_captcha(),
    };

    return data;
  };

  override(LogInModal.prototype, 'onsubmit', function (original, e) {
    e.preventDefault();

    this.loading = true;

    checkUser(this.identification(), () => {
      if (need_captcha && !this_captcha()) {
        this.loading = false;
        app.alerts.show({ type: 'error' }, '请输入验证码');
        this_captcha('');
        $('.Form-control--captcha--input').focus();
        return;
      }
      app
        .request({
          method: 'POST',
          url: `${app.forum.attribute('apiUrl')}/cjlu/auth/login`,
          body: this.loginParams(),
          errorHandler: this.onerror.bind(this),
        })
        .then(() => window.location.reload(), this.loaded.bind(this));
    });


  });
}
